export const activity: Record<string, string> = {
  '{count} activity markers': '{count} marqueurs d’activité',
  '{count} alarm has no known position': '{count} alarme sans position connue',
  '{count} alarms at this position': '{count} alarmes à cette position',
  '{count} alarms have no known position': '{count} alarmes sans position connue',
  '{count} filter active': '{count} filtre actif',
  '{count} filters active': '{count} filtres actifs',
  '{count} min': '{count} min',
  '{count} shift not reporting': '{count} vacation sans signal',
  '{count} shifts not reporting': '{count} vacations sans signal',
  '{count} patrol routes': '{count} itinéraires de ronde',
  '{count} route-only': '{count} avec itinéraire uniquement',
  '{count} skipped': '{count} ignorés',
  '{count} total activity markers': '{count} marqueurs d’activité au total',
  '{duration} logged': '{duration} enregistrées',
  '{hours} h {minutes} min': '{hours} h {minutes} min',
  '{name} — last known location': '{name} — dernière position connue',
  '{name} — no position for {age}': '{name} — aucune position depuis {age}',
  '{name} — no position since clock-in': '{name} — aucune position depuis la prise de service',
  '{name} — no signal for {age}': '{name} — aucun signal depuis {age}',
  'Active alarms': 'Alarmes actives',
  'ALARM': 'ALARME',
  'ALARM ACTIVE': 'ALARME ACTIVE',
  'All sites': 'Tous les sites',
  'All statuses': 'Tous les statuts',
  'Attendance window': 'Plage de présence',
  'Battery: {level}%': 'Batterie : {level} %',
  'Break': 'Pause',
  'Break coverage': 'Couverture des pauses',
  'Break Coverage': 'Couverture des pauses',
  'Break Ended': 'Pause terminée',
  'Break Started': 'Pause commencée',
  'Center on Guards': 'Centrer sur les agents',
  'Checkpoint': 'Point de contrôle',
  'Checkpoint {number}': 'Point de contrôle {number}',
  'Checkpoints': 'Points de contrôle',
  'Collapse panel': 'Réduire le panneau',
  'Date': 'Date',
  'Events': 'Événements',
  'Execution event': 'Événement d’exécution',
  'Exit patrol focus': 'Quitter le suivi de la ronde',
  'Expand panel': 'Développer le panneau',
  'Filter by site': 'Filtrer par site',
  'Find completed shifts fast, then inspect routes, patrol coverage and attendance activity without losing map space.':
    'Trouvez rapidement les vacations terminées, puis examinez les itinéraires, la couverture des rondes et les présences sans réduire l’espace de la carte.',
  'GPS samples captured': 'Relevés GPS enregistrés',
  'GPS trail': 'Tracé GPS',
  'Guard activity': 'Activité des agents',
  'Guard: {name}': 'Agent : {name}',
  'Guards ({count})': 'Agents ({count})',
  'Hide alarms on the map': 'Masquer les alarmes sur la carte',
  'Hide last location': 'Masquer la dernière position',
  'Jump': 'Accéder',
  'Jump to {time}': 'Accéder à {time}',
  'Last known location': 'Dernière position connue',
  'Last known location of {name}': 'Dernière position connue de {name}',
  'Last position reported by the guard': 'Dernière position transmise par l’agent',
  'Last position reported by the guard, {age} ago': 'Dernière position transmise par l’agent, il y a {age}',
  'Last seen: {time}': 'Dernière activité : {time}',
  'Last update: {time}': 'Dernière mise à jour : {time}',
  'Late': 'En retard',
  'Late arrival by {count} minutes': 'Arrivée en retard de {count} minutes',
  'Live operations': 'Opérations en direct',
  'Loading map': 'Chargement de la carte',
  'Map': 'Carte',
  'Map unavailable': 'Carte indisponible',
  'Markers {count}': 'Marqueurs {count}',
  'Monitor field teams in real time, filter by site and review shift history from one operational view.':
    'Suivez les équipes terrain en temps réel, filtrez par site et consultez l’historique des vacations depuis une seule vue opérationnelle.',
  'No activity markers are available for this replay.':
    'Aucun marqueur d’activité n’est disponible pour cette relecture.',
  'No activity matches the selected timeline filter.':
    'Aucune activité ne correspond au filtre chronologique sélectionné.',
  'No break entries were recorded for this shift.':
    'Aucune pause n’a été enregistrée pour cette vacation.',
  'No breaks recorded': 'Aucune pause enregistrée',
  'No GPS data': 'Aucune donnée GPS',
  'No GPS history was captured for this shift':
    'Aucun historique GPS n’a été enregistré pour cette vacation',
  'No guards for this site filter': 'Aucun agent pour ce filtre de site',
  'No location points were captured for this replay range.':
    'Aucun point de localisation n’a été enregistré pour cette plage de relecture.',
  'No offline guards': 'Aucun agent hors ligne',
  'No online guards': 'Aucun agent en ligne',
  'No operational issues detected in the replay data':
    'Aucun problème opérationnel détecté dans les données de relecture',
  'No patrol runs recorded': 'Aucune ronde enregistrée',
  'No patrol runs were attached to this shift.':
    'Aucune ronde n’était associée à cette vacation.',
  'No shifts match the current replay filters.':
    'Aucune vacation ne correspond aux filtres de relecture actuels.',
  'No position for {age}': 'Aucune position depuis {age}',
  'No signal': 'Aucun signal',
  'No signal for {age} — position may be out of date':
    'Aucun signal depuis {age} — la position peut être périmée',
  'Offline': 'Hors ligne',
  'Offline ({count})': 'Hors ligne ({count})',
  'On time': 'À l’heure',
  'Online': 'En ligne',
  'Online ({count})': 'En ligne ({count})',
  'Online: {online} | Offline: {offline}': 'En ligne : {online} | Hors ligne : {offline}',
  'Open||shift window': 'Ouverte',
  'Operational Flags': 'Alertes opérationnelles',
  'Paid': 'Rémunérée',
  'Paid break': 'Pause rémunérée',
  'Patrol': 'Ronde',
  'Patrol checkpoints': 'Points de contrôle de la ronde',
  'Patrol Completed': 'Ronde terminée',
  'Patrol focus': 'Suivi de la ronde',
  'Patrol focus: {name}': 'Suivi de la ronde : {name}',
  'Patrol Replay': 'Relecture de la ronde',
  'Patrol route': 'Itinéraire de ronde',
  'Patrol Routes': 'Itinéraires de ronde',
  'Patrol Started': 'Ronde commencée',
  'Pause replay': 'Suspendre la relecture',
  'Play replay': 'Lancer la relecture',
  'Playback is bounded to a dedicated stage. Event markers pulse on the route and timeline markers are clickable from the scrubber.':
    'La lecture s’effectue dans une zone dédiée. Les marqueurs d’événement clignotent sur l’itinéraire et les marqueurs chronologiques sont accessibles depuis la barre de lecture.',
  'Points {count}': 'Points {count}',
  'Position when the alarm was raised': 'Position au déclenchement de l’alarme',
  'Position when the alarm was raised (±{metres} m)': 'Position au déclenchement de l’alarme (±{metres} m)',
  'Range': 'Plage',
  'Recent Activity': 'Activité récente',
  'Replay': 'Relecture',
  'Replay data is unavailable': 'Les données de relecture sont indisponibles',
  'Replay fidelity': 'Fidélité de la relecture',
  'Replay Library': 'Bibliothèque de relectures',
  'Replay Workspace': 'Espace de relecture',
  'Restart': 'Recommencer',
  'Restart replay': 'Recommencer la relecture',
  'Scanned: {time}': 'Scanné : {time}',
  'Search by guard or site': 'Rechercher par agent ou par site',
  'Select a completed shift': 'Sélectionner une vacation terminée',
  'Selected Replay': 'Relecture sélectionnée',
  'Shift Intelligence': 'Analyse des vacations',
  'Shift Replay': 'Relecture de la vacation',
  'Shift route playback': 'Lecture de l’itinéraire de la vacation',
  'Show alarms on the map': 'Afficher les alarmes sur la carte',
  'Show last location': 'Afficher la dernière position',
  'Site location — no GPS position for this alarm': 'Emplacement du site — aucune position GPS pour cette alarme',
  'Site: {name}': 'Site : {name}',
  'Sort': 'Trier',
  'Speed': 'Vitesse',
  'Speed: {speed} m/s': 'Vitesse : {speed} m/s',
  'Status: {status}': 'Statut : {status}',
  'The guard may have had location history disabled, or this patrol has no recorded track.':
    'L’agent avait peut-être désactivé l’historique de localisation, ou cette ronde ne comporte aucun tracé enregistré.',
  'The replay workspace is now optimized for scale. Pick a shift from the library to inspect route playback, patrol checkpoints and activity markers.':
    'L’espace de relecture est optimisé pour les opérations à grande échelle. Choisissez une vacation dans la bibliothèque pour examiner l’itinéraire, les points de contrôle et les marqueurs d’activité.',
  'The selected shift could not be loaded. Try another replay from the library.':
    'Impossible de charger la vacation sélectionnée. Essayez une autre relecture de la bibliothèque.',
  'Total': 'Total',
  'Triggered: {time}': 'Déclenchée : {time}',
  'Unassigned': 'Non affecté',
  'unknown': 'inconnu',
  'View {name}': 'Voir {name}',
  'View alarm': 'Voir l’alarme',
  'View alarm: {title}': 'Voir l’alarme : {title}',
  'View full shift': 'Voir toute la vacation',
  'Viewing': 'Affichage',
  'Visible': 'Visibles',
  'Window': 'Plage',
  'Pause': 'Pause',
  'Play': 'Lecture',
  '{count} result': '{count} résultat',
  '{count} results': '{count} résultats',
};
